const Index = () =>
  import(
    /* webpackChunkName: "creatorCenter~index" */ 'page/platform/creatorCenter/index.vue'
  )

let routes = [
  {
    path: '/creatorCenter/index',
    component: Index,
    meta: {
      pageName: '创作者中心',
      business: '平台',
      title: '创作者中心'
    }
  }
]

export default routes
